import { SvgIcon, SxProps } from "@mui/material";
import CircleCheckSvg from "jsx:../../../Images/Icons/FontAwesome/solid/circle-check.svg";

export function CircleCheckSolidIcon(props: SxProps) {
    return <SvgIcon component={CircleCheckSvg} inheritViewBox sx={props} />;
}
